// ตัว resolve เส้นทางหน้าเป้าหมายจากแจ้งเตือน (RefType + RefId)
// เพิ่มจุดแจ้งเตือนใหม่ในระบบ = เพิ่ม 1 บรรทัดในแมพนี้ + ให้ backend ส่ง RefType ให้ตรง
// (ค่าเส้นทางอ้างอิงจากที่ประกาศไว้ใน src/App.js)
export const NOTIFICATION_LINKS = {
  SALE_ORDER: (n) => `/CustomerSupport/EditSaleOrder/${n.RefId}`,

  // เผื่อจุดอื่นในระบบ — ผูกไว้ล่วงหน้าตาม route ที่มีอยู่
  SHIP_INBOUND: (n) => `/Ship/EiditInbound/${n.RefId}`,
  SHIP_OUTBOUND: (n) => `/Ship/EiditOutbound/${n.RefId}`,
  TRAIN_INBOUND: (n) => `/Train/EditInboundtrain/${n.RefId}`,
  TRAIN_OUTBOUND: (n) => `/Train/EditOutboundtrain/${n.RefId}`,
  TRUCK_INBOUND: (n) => `/Truck/EditInboundTruck/${n.RefId}`,
  TRUCK_OUTBOUND: (n) => `/Truck/EditOutboundTruck/${n.RefId}`,
};

// คืน path สำหรับ history.push หรือ null ถ้าไม่รู้จัก RefType (จะไม่ทำ navigate)
export function resolveNotificationLink(notification) {
  if (!notification) return null;
  const builder = NOTIFICATION_LINKS[notification.RefType];
  if (!builder || !notification.RefId) return null;
  return builder(notification);
}
